var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0C11.26 0 5 6.26 5 14C5 22.4153 13.9927 34.0422 17.5635 38.3274C18.322 39.2376 19.678 39.2376 20.4365 38.3274C24.0073 34.0422 33 22.4153 33 14C33 6.26 26.74 0 19 0Z",
    fill: "#FFB45A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6734 22.0002L21.3332 8.66016H17.6345L12.2734 22.0002H15.515L16.3877 19.7002H22.5799L23.4527 22.0002H26.6734ZM21.7695 17.2402H17.1773L19.4838 11.1202L21.7695 17.2402Z",
    fill: "#000838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIcon);
export default __webpack_public_path__ + "static/media/A_Icon.12ab26dcc18feb373605f01c475aea50.svg";
export { ForwardRef as ReactComponent };